export default {
  selectDefault: {
    width: 300
  },
  outlinedPlaceholder: {
    position: 'absolute',
    left: '12px',
    top: '11px',
    pointerEvents: 'none',
    transition: '0.2s ease all',
    color: '#6D709B',
  },
  outlinedLabel: {
    top: '-11px',
    padding: '0 4px',
    marginLeft: '-4px',
    color: '#9597BD',
  },
  outlinedGradientLinear: {
    background: 'linear-gradient(to bottom, white 50%, #f5f5f5 50%)'
  },
  outlinedWhiteBg: {
    background: 'white'
  }
};
